export const mockData = {
  en: {
    buttons: { epaper: "E-paper" },
    nav: [
      "Home",
      "Videos",
      "Shorts",
      "Ahmedabad",
      "Gujarat",
      "India",
      "World",
      "Business",
      "Sports",
      "Entertainment",
      "Lifestyle",
      "Technology",
    ],
    heroArticle: { readMore: "Read More" },
    headings: {
      topNews: "Top News",
      trending: "Trending",
      localNews: "Ahmedabad",
      gujaratNews: "Gujarat News",
      indiaNews: "India News",
      worldNews: "World News",
      videos: "Videos",
      reels: "Reels",
      relatedNews: "Related News",
    },
    footer: {
      services: "Services",
      legal: "Legal",
      links: {
        epaper: "E-Paper",
        terms: "Terms of Use",
        privacy: "Privacy Policy",
        cookie: "Cookie Policy",
      },
      copyright: "Amdavad Post. All Rights Reserved. © 2023 amdavadpost.in",
    },
  },
  gu: {
    buttons: { epaper: "ઈ-પેપર" },
    nav: [
      "હોમ",
      "વીડિયો",
      "શોર્ટ્સ",
      "અમદાવાદ",
      "ગુજરાત",
      "ભારત",
      "વિશ્વ",
      "બિઝનેસ",
      "સ્પોર્ટ્સ",
      "મનોરંજન",
      "જીવનશૈલી",
      "ટેકનોલોજી",
    ],
    heroArticle: { readMore: "વધુ વાંચો" },
    headings: {
      topNews: "મુખ્ય સમાચાર",
      trending: "ટ્રેન્ડિંગ",
      gujaratNews: "ગુજરાત સમાચાર",
      indiaNews: "ભારત સમાચાર",
      worldNews: "વિશ્વ સમાચાર",
      videos: "વીડિયો",
      reels: "રીલ્સ",
      relatedNews: "સંબંધિત સમાચાર",
    },
    footer: {
      services: "સેવાઓ",
      legal: "કાનૂની",
      links: {
        epaper: "ઈ-પેપર",
        archives: "આર્કાઇવ્સ",
        terms: "ઉપયોગની શરતો",
        privacy: "ગોપનીયતા નીતિ",
        cookie: "કૂકી નીતિ",
      },
      copyright: "અમદાવાદ પોસ્ટ. સર્વાધિકાર સુરક્ષિત.",
    },
  },
};

export const customStyles = `
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
`;
